<template>
  <RevButton
    v-if="
      ['MERCHANT_NEED_TO_SEND', 'SENT'].includes(order.state.code) &&
      Boolean(order.deliveryFormLink)
    "
    class="w-full"
    :data-qa="`print-packing-slip-${order.id}`"
    size="small"
    variant="secondary"
    @click="handlePrintPackingSlip"
  >
    {{ i18n(translations.printPackingSlip) }}
  </RevButton>
  <RevButton
    v-if="
      ['MERCHANT_NEED_TO_SEND', 'SENT'].includes(order.state.code) &&
      Boolean(order.shipping?.shipmentLabelLink)
    "
    class="w-full"
    :data-qa="`print-backship-label-${order.id}`"
    size="small"
    variant="secondary"
    @click="handlePrintBackshipLabel"
  >
    {{ i18n(translations.printBackShipLabel) }}
  </RevButton>
  <RevButton
    v-if="order.state.code === 'MERCHANT_NEED_TO_SEND'"
    class="w-full"
    :data-qa="`ship-${order.id}`"
    size="small"
    variant="secondary"
    @click="handleShip"
  >
    {{ i18n(translations.ship) }}
  </RevButton>
  <RevButton
    v-if="
      hasCustomerReceiptEnabled &&
      order.state.code === 'SENT' &&
      !order.isInvoiceProvided
    "
    class="w-full"
    :data-qa="`send-customer-receipt-${order.id}`"
    size="small"
    variant="secondary"
    @click="handleSendCustomerReceipt"
  >
    {{ i18n(translations.sendCustomerReceipt) }}
  </RevButton>
  <SendCustomerReceiptDrawer :order-id="order.id" :refresh-orders />
  <ShipOrderDrawer :order :refresh-orders />
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { openModal } from '@ds/components/ModalBase'

import { useBusinessFeaturesStore } from '~/scopes/config/stores/businessFeaturesStore'

import type { Order } from '../../../../../../Tab.types'

import translations from './OrderActions.translations'
import { MODAL_NAME as SEND_CUSTOMER_RECEIPT_DRAWER } from './components/SendCustomerReceiptDrawer/SendCustomerReceiptDrawer.constants'
import SendCustomerReceiptDrawer from './components/SendCustomerReceiptDrawer/SendCustomerReceiptDrawer.vue'
import { MODAL_NAME as SHIP_ORDER_DRAWER } from './components/ShipOrderDrawer/ShipOrderDrawer.constants'
import ShipOrderDrawer from './components/ShipOrderDrawer/ShipOrderDrawer.vue'

const i18n = useI18n()

const props = defineProps<{ order: Order; refreshOrders: () => void }>()

const { isFeatureEnabled } = useBusinessFeaturesStore()
const hasCustomerReceiptEnabled = isFeatureEnabled('customerReceiptEnabled')

function handlePrintPackingSlip() {
  window.open(props.order.deliveryFormLink?.href, '_blank')
}

function handlePrintBackshipLabel() {
  window.open(props.order.shipping?.shipmentLabelLink?.href, '_blank')
}

function handleShip() {
  openModal(SHIP_ORDER_DRAWER + props.order.id)
}

function handleSendCustomerReceipt() {
  openModal(SEND_CUSTOMER_RECEIPT_DRAWER + props.order.id)
}
</script>
